"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var AcLink_1 = __importDefault(require("./AcLink"));
function AcLi(props) {
    var collapsed = props.collapsed, title = props.title, links = props.links, desc = props.desc, backgroundUrl = props.backgroundUrl, bgTitle = props.bgTitle, footerLink = props.footerLink, isMobile = props.isMobile, onClick = props.onClick, extendProps = props.extendProps;
    function renderLinks() {
        return (react_1.default.createElement("div", { className: "li-links" }, links.map(function (l, i) { return (react_1.default.createElement(AcLink_1.default, __assign({ key: "ac-link-".concat(i) }, l))); })));
    }
    function renderFooterLink() {
        var text = footerLink.text, to = footerLink.to;
        if (!text) {
            return null;
        }
        return (react_1.default.createElement("a", __assign({ className: "footer-link", href: to }, (extendProps || {})),
            text,
            react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "15", height: "12", viewBox: "0 0 15 12", fill: "none" },
                react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 1.48679L8.58871 0L15 6L8.58871 12L7 10.5132L10.8921 7H0V5H10.8921L7 1.48679Z", fill: "currentColor" }))));
    }
    function renderImage() {
        return react_1.default.createElement("img", { className: "accordion-img", src: backgroundUrl, alt: bgTitle });
    }
    function renderCollapseDetail() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", { className: "li-desc" }, desc),
            renderLinks(),
            renderFooterLink()));
    }
    var liCls = collapsed ? 'collapsed' : 'common';
    return (react_1.default.createElement("li", { className: (0, classnames_1.default)('accordion-li', isMobile ? 'mobile' : liCls), onClick: onClick },
        renderImage(),
        react_1.default.createElement("div", { className: "li-content" },
            react_1.default.createElement("div", { className: "content-main" },
                react_1.default.createElement("h2", { className: "li-title" }, title),
                collapsed || isMobile ? renderCollapseDetail() : null))));
}
exports.default = AcLi;
//# sourceMappingURL=AcLi.js.map